import React, { useState, useEffect } from 'react'

import Header from '../baseComponents/Header'
import SearchResponsive from '../baseComponents/Search';
import Footer from '../baseComponents/Footer'
import SanferRedLabel from '../baseComponents/SanferRedLabel'
import Search from '../pages/Search'

const MainLayout = props => {
  const { id = 'item', className = '', logo, redLabel = true } = props
    , [search, setSearch] = useState('')
    , [showSearchForm, setShowForm] = useState(false)

  const onSearch = () => {
    if (search.trim().length) {
      setShowForm(true)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (showSearchForm) return <Search onSearchTextChange={setSearch} searchText={search} />


  return <div id={id} className={`page__layout ${className}`} >
    <Header onSearch={onSearch} onSearchTextChange={setSearch} searchText={search}/>
    <SearchResponsive onSearch={onSearch} onSearchTextChange={setSearch} searchText={search}/>
    {
      redLabel &&
      <SanferRedLabel />
    }
    <div className='container'>
      {props.children}
    </div>
    <Footer />
    {
      logo && <div className='page__background-logo transition'>
        {logo}
      </div>
    }

  </div>
}

export default MainLayout